import React from "react";
import { Toast, Icon } from "antd-mobile";
import { post } from "../../utils/request";
import { href } from "../../utils/util";

import api from "./api";

import "./index.less";

class InviteNewUsersIndex extends React.Component {
    constructor(...args) {
        super(...args);
        this.state = {
            urlOps: {},
            detailData: {},
            status: false,
        };
    }

    // #/inviteNewUsersIndex?app_stoken=1111&phoneNumber=13333333333
    componentDidMount() {
        var obj = "",
            obj1 = "",
            ops = {};
        if (window.location.hash.indexOf("?") > -1) {
            obj = window.location.hash.split("?")[1];
            obj1 = obj.split("&");
            for (var i = 0; i < obj1.length; i++) {
                ops[obj1[i].split("=")[0]] =
                    obj1[i].split("=")[1] === "undefined"
                        ? ""
                        : obj1[i].split("=")[1];
            }
            if (
                ops.app_stoken === "null" ||
                ops.app_stoken === "(null)" ||
                ops.app_stoken === "undefined" ||
                !ops.app_stoken
            ) {
                Toast.fail("请登录APP再进行操作", 999);
                return;
            }

            this.setState(
                {
                    urlOps: ops,
                },
                () => {
                    if (ops.app_stoken && ops.app_stoken != "null") {
                        this.getInviteTop();
                    }
                }
            );
        }
    }

    // 获取详情
    getInviteTop() {
        const { urlOps } = this.state;
        post({
            url: api.inviteTop + "?app_stoken=" + urlOps.app_stoken,
            data: {},
        }).then(
            (res) => {
                if (res.result === "success") {
                    this.setState({
                        detailData: res.data,
                        status: false,
                    });
                } else {
                    this.setState({
                        status: true,
                    });
                    Toast.info(res.msg, 1);
                }
            },
            (res) => {
                Toast.info("登录失效", 1);
            }
        );
    }

    // 获取邀请码
    getInsertInvite() {
        const { urlOps, detailData } = this.state;
        console.log(detailData);
        post({
            url: api.insertInvite + "?app_stoken=" + urlOps.app_stoken,
            data: {
                activityCode: detailData.activityCode,
                inviteType: 1,
                invitePhoneNumber: urlOps.phoneNumber,
            },
        }).then(
            (res) => {
                if (res.result === "success") {
                    this.appShare(
                        {
                            title: `注册远程慧联app即可获得5元充电券`,
                            url: `${window.location.origin}${
                                window.location.pathname
                            }#/inviteNewUsersShare?lastNumber=${urlOps.phoneNumber.slice(
                                7,
                                11
                            )}&inviteCode=${res.data}`,
                            cotent: `充电券免费送，邀请越多奖励越多，还有机会瓜分千元充电大礼包。`,
                            img: "https://static.hellogil.com/oss-prod-unsafe-group/statics/6a8009d8063148ccb0ec9b39b02f41b3.png",
                        },
                        true
                    );
                    console.log(
                        `${window.location.origin}${
                            window.location.pathname
                        }#/inviteNewUsersShare?lastNumber=${urlOps.phoneNumber.slice(
                            7,
                            11
                        )}&inviteCode=${res.data}`
                    );
                } else {
                    Toast.info(res.msg, 1);
                }
            },
            (res) => {
                Toast.info("获取邀请码失败", 1);
            }
        );
    }
    viewPort = () => {
        let u = navigator.userAgent.toLowerCase();
        return {
            isWeixin: u.indexOf("micromessenger") > -1,
            isQQ: u.indexOf("qq/") > -1,
            trident: u.indexOf("trident") > -1, //IE内核
            presto: u.indexOf("presto") > -1, //opera内核
            webKit: u.indexOf("applewebkit") > -1, //苹果、谷歌内核
            gecko: u.indexOf("gecko") > -1 && u.indexOf("khtml") == -1, //火狐内核
            mobile:
                !!u.match(/applewebkit.*mobile.*/) || !!u.match(/applewebkit/), //是否为移动终端
            ios: !!u.match(/\(i[^;]+;( u;)? cpu.+mac os x/), //ios终端
            android: u.indexOf("android") > -1 || u.indexOf("linux") > -1, //android终端或者uc浏览器
            iPhone: u.indexOf("iphone") > -1 || u.indexOf("mac") > -1, //是否为iPhone或者QQHD浏览器
            iPad: u.indexOf("ipad") > -1, //是否iPad
            webApp: u.indexOf("safari") == -1, //是否web应该程序，没有头部与底部
        };
    };

    appShare(ops, shareType) {
        let viewPort = this.viewPort();
        if (viewPort.ios || viewPort.iPhone || viewPort.iPad) {
            if (window.webkit) {
                // if(shareType){
                // window.webkit.messageHandlers.showShare.postMessage(ops);
                // }else{
                window.webkit.messageHandlers.share.postMessage(ops);
                // }
            }
        } else {
            if (window.huilian) {
                // if(shareType){
                // window.huilian.showShareWeixin(ops.url, ops.title, ops.cotent, ops.img);
                // }else{
                window.huilian.shareWeixin(
                    ops.url,
                    ops.title,
                    ops.cotent,
                    ops.img
                );
                // }
            }
        }
    }

    render() {
        const { urlOps, detailData, status } = this.state;
        return (
            <div className="InviteNewUsersIndexBox">
                <div className="rewardBox">
                    <div className="reward_1_row">
                        <span>累计奖励</span>
                        <p>
                            当前排名：
                            <span>{detailData.currentOrder || 0}</span>
                        </p>
                    </div>
                    <div className="reward_2_row">
                        <p>
                            {detailData.currentAmount || 0}
                            <span>元</span>
                        </p>
                        <span
                            onClick={() => {
                                href(
                                    `/inviteNewUsersDetail?app_stoken=${urlOps.app_stoken}&activityCode=${detailData.activityCode}`
                                );
                            }}
                        >
                            明细
                            <Icon
                                type="right"
                                color="#bbb"
                            />
                        </span>
                    </div>
                    {status ? (
                        <div className="reward_4_row">活动已结束</div>
                    ) : (
                        <div
                            className="reward_3_row"
                            onClick={() => {
                                this.getInsertInvite();
                            }}
                        >
                            邀请好友
                        </div>
                    )}
                </div>
                <div className="rankingBox">
                    <h2>邀请排名</h2>
                    <div>
                        {detailData.ranks
                            ? detailData.ranks.map((item, index) => {
                                  return (
                                      <div
                                          className={{
                                              one: item.rankOrder == 1,
                                              two: item.rankOrder == 2,
                                              three: item.rankOrder == 3,
                                          }}
                                          key={"paiming_" + index}
                                      >
                                          <div>第{item.rankOrder}名</div>
                                          <div>{item.customerName || "--"}</div>
                                          <div>
                                              邀请{item.inviteCount || 0}人
                                          </div>
                                          <div>
                                              已获得{item.rewardAmount || 0}元
                                          </div>
                                      </div>
                                  );
                              })
                            : ""}
                    </div>
                </div>
                <div>
                    <h2>活动规则</h2>
                    <div style={{ lineHeight: "1.5", whiteSpace: "pre-line" }}>
                        {detailData.activityContent}
                    </div>
                </div>
            </div>
        );
    }
}

export default InviteNewUsersIndex;



// WEBPACK FOOTER //
// ./src/inviteNewUsers/index/index.js